import { render, staticRenderFns } from "./group-preview.vue?vue&type=template&id=53ca55dc&scoped=true"
import script from "./group-preview.vue?vue&type=script&lang=ts"
export * from "./group-preview.vue?vue&type=script&lang=ts"
import style0 from "./group-preview.vue?vue&type=style&index=0&id=53ca55dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca55dc",
  null
  
)

export default component.exports